<template>
  <v-container style="background: #f5f5f5">
    <app-spinner v-if="loading" />
    <template v-else>
      <v-container>
        <v-row v-if="!isVoucherRedeemed">
          <v-col cols="12" justify="center">
            <div class="text-h5 font-weight-light text-center mb-5">{{ business.brand }}</div>
            <div class="instructions-header">{{ offer.offer_order_flow_type === 'VISIT' ? 'CASHIER' : 'EMPLOYEE' }} INSTRUCTIONS:</div>
            <div class="instructions-content">
              1. Press the "Mark as Used" button <br />
              2. Not valid w/ other offers or promotions
            </div>
          </v-col>
        </v-row>

        <template v-else>
          <v-row>
            <v-col cols="3">
              <v-img :src="require(`@/assets/camera.svg`)" height="100px" contain class="ma-auto" />
            </v-col>
            <v-col cols="9">
              <v-row>
                <v-col cols="12">Success! Don't forget to take a photo for your post or review!</v-col>
              </v-row>
              <v-row class="mt-1">
                <v-col cols="12" class="text-right">
                  <v-btn rounded color="primary" width="100%" @click="$router.go(-1)"> Next Step <v-icon class="pl-2">mdi-arrow-right-circle</v-icon> </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-container>

      <LfVoucherTicket
        :business-logo-url="business.logo_url"
        :business-brand="business.brand"
        :address="address"
        :ticket-summary="offer.offer_summary"
        :special-instructions="offer.offer_special_instructions"
        :min-days-between-offer="offer.min_days_between_offer"
        :coupon-code="(code && code.code_val) || offer.coupon_code"
        :redeeming="activateVoucherLoading"
        :date-redeemed="voucher.date_redeemed"
        :date-voucher-expires="(eventDate && eventDate.event_date) || voucher.date_expires"
        @activate-voucher-clicked="activateVoucher"
      />
    </template>
  </v-container>
</template>

<script>
import Vue from 'vue'

import { ApiService } from '@/services'

import { LfVoucherTicket } from 'lf-common'

export default Vue.extend({
  name: 'Coupon',

  components: {
    LfVoucherTicket,
  },

  metaInfo() {
    return {
      title: `${this.business.brand} | Coupon`,
    }
  },

  data: () => ({
    loading: true,
    activateVoucherLoading: false,
    offer: {},
    voucher: {},
    business: {},
    code: {},
    address: {},
    eventDate: {},
  }),

  computed: {
    isVoucherRedeemed: function () {
      return this.voucher && this.voucher.date_redeemed
    },
  },

  mounted: function () {
    ApiService.get(`coupon/${this.$router.currentRoute.params.voucherId}`).then((response) => {
      this.loading = false
      this.business = response.data.business
      this.voucher = response.data.voucher
      this.offer = response.data.offer
      this.code = response.data.code
      this.address = response.data.address
      this.eventDate = response.data.eventDate
    })
  },

  methods: {
    activateVoucher: function () {
      if (this.activateVoucherLoading) return

      this.activateVoucherLoading = true

      ApiService.put(`voucherWorkflow/markAsUsed/${this.voucher.id}`, {}).then((response) => {
        this.activateVoucherLoading = false
        this.voucher = response.data.voucher
        this.code = response.data.code

        this.$store.dispatch('reservations/fetchReservationSummary')

        this.$nextTick(() => {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
          })
        })
      })
    },
  },
})
</script>

<style scoped lang="scss">
.instructions-header {
  margin-bottom: 8px;
  color: #ed1e56;
  font-size: 17px;
  font-weight: 700;
}

.instructions-content {
  font-size: 16px;
  font-weight: 700;
}
</style>
